import { render, staticRenderFns } from "./DashboardTaskItem.vue?vue&type=template&id=01e5ef83&scoped=true&lang=pug&"
import script from "./DashboardTaskItem.vue?vue&type=script&lang=js&"
export * from "./DashboardTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTaskItem.vue?vue&type=style&index=0&id=01e5ef83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e5ef83",
  null
  
)

/* custom blocks */
import block0 from "./DashboardTaskItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports